module.exports = __webpack_public_path__ + "assets/img/1.22e5f500.jpg";